// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-upload-container .template-upload-header {
  font-size: 1.75rem;
  font-weight: bold;
  color: var(--ion-color-primary-black);
  text-transform: uppercase;
}
.template-upload-container .rating-container {
  padding: 1.25rem 0 1.875rem;
}
.template-upload-container ion-row {
  margin-top: 1.3125rem;
}
.template-upload-container ion-row ion-col {
  padding: 0 0.4375rem;
  display: contents;
}
.template-upload-container ion-row ion-col .common-input {
  width: 100%;
  position: relative;
  border: 1px solid #ccc;
}
.template-upload-container ion-row ion-col:first-child {
  padding-left: 0;
}
.template-upload-container ion-row ion-col:last-child {
  padding-right: 0;
}

.uploadImage-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1.5625rem 1.875rem;
}
.uploadImage-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.uploadImage-bottom-container .cancel:hover {
  font-weight: 600;
}
.uploadImage-bottom-container .product-button ion-button {
  --background: var(--ion-color-primary);
  width: 100px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}

.progress {
  background-color: #D5DADC;
  border-radius: 100px;
  display: flex;
  font-size: 1.2rem;
  height: 0.375rem;
  overflow: hidden;
  margin-top: 0.75rem;
}

.progress-bar {
  align-items: center;
  background-color: #0081ca;
  color: #fff;
  display: flex;
  justify-content: center;
}

.select-label-text {
  position: relative;
  border: none;
}

.mass-upload-btn {
  width: 171px;
  height: 46px;
  background: var(--ion-color-primary) 0% 0% no-repeat padding-box;
  opacity: 1;
  font: normal normal bold 0.9375rem/1.25rem Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-white);
  text-transform: uppercase;
  opacity: 1;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.justify-centre {
  justify-content: center;
}

.download-template-btn {
  width: 150px;
}

.download-arrow {
  margin-bottom: 5px;
}
.download-arrow img {
  filter: brightness(0) invert(1);
}

.center {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.close-div {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  width: 100%;
  top: 0.3125rem;
  left: 0;
}
.close-div .close-icon {
  cursor: pointer;
  max-width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/template-download/template-download.component.scss"],"names":[],"mappings":"AACC;EACC,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;AAAF;AAKC;EACC,2BAAA;AAHF;AAOC;EACC,qBAAA;AALF;AAOE;EACC,oBAAA;EACA,iBAAA;AALH;AAOG;EACC,WAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AASE;EACC,eAAA;AAPH;AAUE;EACC,gBAAA;AARH;;AAaA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;AAVD;AAYC;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AAVF;AAYE;EACC,gBAAA;AAVH;AAeE;EACC,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAbH;;AAkBA;EACC,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAfD;;AAkBA;EACC,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAfD;;AAkBA;EACC,kBAAA;EACA,YAAA;AAfD;;AAkBA;EACC,YAAA;EACA,YAAA;EACA,gEAAA;EACA,UAAA;EACA,oDAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;EACA,UAAA;AAfD;;AAkBA;EACC,yBAAA;AAfD;;AAkBA;EACC,2BAAA;AAfD;;AAkBA;EACC,uBAAA;AAfD;;AAkBA;EACC,YAAA;AAfD;;AAkBA;EACC,kBAAA;AAfD;AAiBC;EACC,+BAAA;AAfF;;AAmBA;EACC,aAAA;EACA,uBAAA;EACA,aAAA;AAhBD;;AAmBA;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,OAAA;AAhBD;AAkBC;EACC,eAAA;EACA,eAAA;AAhBF","sourcesContent":[".template-upload-container {\n\t.template-upload-header {\n\t\tfont-size: 1.75rem;\n\t\tfont-weight: bold;\n\t\tcolor: var(--ion-color-primary-black);\n\t\ttext-transform: uppercase;\n\t}\n\n\n\n\t.rating-container {\n\t\tpadding: 1.25rem 0 1.875rem;\n\t}\n\n\n\tion-row {\n\t\tmargin-top: 1.3125rem;\n\n\t\tion-col {\n\t\t\tpadding: 0 0.4375rem;\n\t\t\tdisplay: contents;\n\n\t\t\t.common-input {\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: relative;\n\t\t\t\tborder: 1px solid #ccc;\n\t\t\t}\n\t\t}\n\n\t\tion-col:first-child {\n\t\t\tpadding-left: 0;\n\t\t}\n\n\t\tion-col:last-child {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n}\n\n.uploadImage-bottom-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tpadding: 1.5625rem 1.875rem;\n\n\t.cancel {\n\t\tfont-weight: 400;\n\t\tfont-size: 0.9375rem;\n\t\tline-height: 1.125rem;\n\t\tletter-spacing: 0.4px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary-black);\n\t\tpadding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.product-button {\n\t\tion-button {\n\t\t\t--background: var(--ion-color-primary);\n\t\t\twidth: 100px;\n\t\t\theight: 46px;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 0.9375rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tletter-spacing: 0.4px;\n\t\t\t--box-shadow: none;\n\t\t\t--border-radius: 0;\n\t\t}\n\t}\n}\n\n.progress {\n\tbackground-color: #D5DADC;\n\tborder-radius: 100px;\n\tdisplay: flex;\n\tfont-size: 1.2rem;\n\theight: 0.375rem;\n\toverflow: hidden;\n\tmargin-top: 0.75rem;\n}\n\n.progress-bar {\n\talign-items: center;\n\tbackground-color: #0081ca;\n\tcolor: #fff;\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.select-label-text {\n\tposition: relative;\n\tborder: none;\n}\n\n.mass-upload-btn {\n\twidth: 171px;\n\theight: 46px;\n\tbackground: var(--ion-color-primary) 0% 0% no-repeat padding-box;\n\topacity: 1;\n\tfont: normal normal bold 0.9375rem /1.25rem Noto Sans;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-white);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.justify-centre {\n\tjustify-content: center;\n}\n\n.download-template-btn {\n\twidth: 150px;\n}\n\n.download-arrow {\n\tmargin-bottom: 5px;\n\n\timg {\n\t\tfilter: brightness(0) invert(1);\n\t}\n}\n\n.center {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 40px;\n}\n\n.close-div {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tposition: absolute;\n\twidth: 100%;\n\ttop: 0.3125rem;\n\tleft: 0;\n\n\t.close-icon {\n\t\tcursor: pointer;\n\t\tmax-width: 40px;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
